export enum RIBBON {
  SOLD_OUT = 'sold-out',
  RSVP_CLOSED = 'rsvp-closed',
  JOIN_WAITLIST = 'join-waitlist',
  MEMBERSHIP = 'membership',
  RECURRING = 'recurring',
}
